(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompetitorDeleteController',CompetitorDeleteController);

    CompetitorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Competitor'];

    function CompetitorDeleteController($uibModalInstance, entity, Competitor) {
        var vm = this;
        vm.competitor = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Competitor.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
